module.exports = __webpack_public_path__ + "static/MM_Public-transport-anxiety-a494eeabb14040ae34f6221c7c2f5efe.mp4";